﻿import React from 'react';
import { DynamicFormHelpTextWrapper } from '../../DynamicForms/Styles/dynamicFormStyles';

export default class DynamicFormHelpText extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            helpTextVisibility: false
        };
    }

    closeHelpText = (e) => {
        document.body.removeEventListener('click', this.closeHelpText, false);
        this.setState({ helpTextVisibility: false });
    }

    toggleHelpText = (e) => {
        const helpTextVisibility = this.state.helpTextVisibility;

        if (!helpTextVisibility) {
            document.body.addEventListener('click', this.closeHelpText);
        }

        this.setState({helpTextVisibility: !helpTextVisibility});
    }

    render() {
        const questionGroupHelpText = this.props.questionGroupHelpText;

        if (questionGroupHelpText !== null) {
            return (
                <DynamicFormHelpTextWrapper helpTextVisibility={this.state.helpTextVisibility}>
                    <button type="button" className="helpTextIcon" onClick={e => this.toggleHelpText(e)}><span>Se ordförklaring.</span></button>
                    <span className="helpText">
                        <span className="helpTextArrow">&nbsp;</span>
                        <span className="helpTextContent">{questionGroupHelpText}</span>
                    </span>
                </DynamicFormHelpTextWrapper>
            );
        }

        return null;
    }
}
